import React, { useState, useEffect } from 'react';
import API from '../services/api';
import { useNavigate, useParams } from 'react-router-dom';
import './AddStudent.css'; // Reuse AddStudent styles

const EditStudent = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '', email: '', roll_number: '', 
    branch: '', phone: '',
    cgpa: '', arrears: '', year_of_study: '', 
    placement_batch_year: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchStudent();
  }, [id]);

  const fetchStudent = async () => {
    try {
      const res = await API.get(`/students/${id}`);
      const s = res.data;
      setForm({
        name: s.name || '',
        email: s.email || '',
        roll_number: s.roll_number || '',
        branch: s.branch || '',
        phone: s.phone || '',
        cgpa: s.cgpa || '',
        arrears: s.arrears || '',
        year_of_study: s.year_of_study || '',
        placement_batch_year: s.placement_batch_year || ''
      });
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch student details');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError(''); setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true); setError(''); setSuccess('');
    try {
      await API.put(`/students/${id}`, form);
      setSuccess('Student updated successfully!');
      setTimeout(() => navigate('/admin/students'), 1500);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update student');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loading-state">Loading student data...</div>;

  return (
    <div className="add-student-page-content">
      <div className="top-bar">
        <div>
          <h2>Edit Student</h2>
          <p>Update student profile information</p>
        </div>
        <button className="back-btn" onClick={() => navigate('/admin/students')}>
          ← Back to Students
        </button>
      </div>

      <div className="add-card">
        {error && <div className="alert error">{error}</div>}
        {success && <div className="alert success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label>Full Name *</label>
              <input name="name" placeholder="Enter full name"
                value={form.name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Roll Number</label>
              <input name="roll_number" placeholder="e.g. 21CS001"
                value={form.roll_number} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Email * (Read-only)</label>
              <input type="email" name="email" value={form.email} disabled />
            </div>
            <div className="form-group">
              <label>Branch</label>
              <select name="branch" value={form.branch} onChange={handleChange}>
                <option value="">Select branch</option>
                <option value="CSE">CSE</option>
                <option value="ECE">ECE</option>
                <option value="EEE">EEE</option>
                <option value="IT">IT</option>
                <option value="MECH">MECH</option>
                <option value="CIVIL">CIVIL</option>
              </select>
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input name="phone" placeholder="Enter phone number"
                value={form.phone} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>CGPA</label>
              <input type="number" step="0.01" name="cgpa" placeholder="e.g. 8.5"
                value={form.cgpa} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Arrears</label>
              <input type="number" name="arrears" placeholder="0"
                value={form.arrears} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Year of Study</label>
              <select name="year_of_study" value={form.year_of_study} onChange={handleChange}>
                <option value="">Select year</option>
                <option value="1">1st Year</option>
                <option value="2">2nd Year</option>
                <option value="3">3rd Year</option>
                <option value="4">4th Year</option>
              </select>
            </div>
            <div className="form-group">
              <label>Placement Batch Year</label>
              <input name="placement_batch_year" placeholder="e.g. 2026"
                value={form.placement_batch_year} onChange={handleChange} />
            </div>
          </div>
          <div className="form-actions">
            <button type="button" className="btn-cancel" onClick={() => navigate('/admin/students')}>Cancel</button>
            <button type="submit" className="btn-submit" disabled={saving}>
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditStudent;
